import { defineStore } from 'pinia';
import {
  createPopulateString,
  parseItemInCollection,
} from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type {
  IBonusTabData,
  IBonusTabDataFromStrapi,
  IBonusTabsStrapiResponse,
} from '~/types/bonuses';

export const useStoreBonusesTabs = defineStore('bonusesTabs', {
  state: () => ({
    tabs: [] as IBonusTabData[],
    requestPromise: null as Promise<IBonusTabsStrapiResponse> | null,
  }),

  actions: {
    async loadBonusesTabs() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['bonusType', 'icon']);

        this.requestPromise = strapi()
          .get('bonuses-tabs', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const parsedData = response.data.map((tab) =>
          parseItemInCollection({
            ...tab,
            bonusType: tab.bonusType.bonusType,
          })
        );
        const filteredState = this.tabs.filter(
          (item) => !parsedData.find(({ id }) => id && id === item.id)
        );

        this.tabs = [...filteredState, ...parsedData].sort((a, b) => a.position - b.position);

        return true;
      } else {
        return false;
      }
    },
    SET_BONUSES_TABS(data: IBonusTabDataFromStrapi[]) {
      const parsedData = data.map((tab) =>
        parseItemInCollection({
          ...tab,
          bonusType: tab.bonusType.bonusType,
        })
      );
      const filteredState = this.tabs.filter(
        (item) => !parsedData.find(({ id }) => id && id === item.id)
      );

      this.tabs = [...filteredState, ...parsedData].sort((a, b) => a.position - b.position);
    },
  },
});
